import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';

const AddPartnerFooter = ({
  onClickNext,
  step,
  disabled,
  onClickSkip
}: {
  onClickNext: () => void;
  onClickSkip: () => void;
  step: number;
  disabled: any;
}) => {
  return (
    <div>
      {step <= 2 && (
        <Button
          small
          color='primary'
          variant='block'
          className='mx-auto'
          onClick={onClickNext}
          disabled={disabled}>
          Next
        </Button>
      )}
      {step >= 3 && (
        <div className='flex items-center gap-6 justify-around'>
          <Button
            small
            color='primary'
            variant='outline'
            className='mx-auto'
            onClick={onClickSkip}
            disabled={disabled}>
            skip
          </Button>
          <Button
            small
            color='primary'
            variant='block'
            className='mx-auto'
            onClick={onClickNext}
            disabled={disabled}>
            Next
          </Button>
        </div>
      )}
    </div>
  );
};

export default AddPartnerFooter;
